export var menuItems={
  "data": [
    {
      "headTitle1": "SPORTACTION.PHOTOS",
      "headTitle2": "Photo search",
      "type": "headtitle"
    },
    {
      "title": "My event",
      "path": "/",
      "type": "link",
      "icon": "stroke-form",
      "iconf":"fill-form",
      "badgeType": "light-primary",
      "active": false,
      

    }
    
  ]
}